import { Component, Input } from '@angular/core';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-button-state',
  templateUrl: './button-state.component.html',
  styleUrls: ['./button-state.component.scss']
})
export class ButtonStateComponent extends ButtonComponent {

  @Input()
  public state: boolean;

  constructor() {
    super();
  }
}
